/** @format */

export interface EventRuleProps {
  eventName: string
  eventNameCn?: string
  eventTags: any[]
  tagList: any[]
  effectBT: string
  effectET: string
  trigger: 1 | 2
  period: number
  accumulatedCount: number
  suppressDuration: number
}

// 事件告警默认参数
export const initEventRuleData: EventRuleProps = {
  eventName: '',
  eventTags: [],
  tagList: [],
  effectBT: '00:00',
  effectET: '23:59',
  trigger: 1,
  period: undefined,
  accumulatedCount: 1,
  suppressDuration: 0
}

// 统计周期
export const PeriodOpts = {
  300: '在5分钟内',
  600: '在10分钟内',
  1800: '在30分钟内',
  3200: '在60分钟内',
  10800: '在3小时内',
  21600: '在6小时内',
  43200: '在12小时内',
  86400: '在24小时内'
}

// 告警间隔
export const SuppressDurationOpts = {
  0: '告警一次',
  300: '间隔5分钟告警一次',
  600: '间隔10分钟告警一次',
  900: '间隔15分钟告警一次',
  1800: '间隔30分钟告警一次',
  3600: '间隔1小时告警一次',
  10800: '间隔3小时告警一次',
  21600: '间隔6小时告警一次',
  43200: '间隔12小时告警一次',
  86400: '间隔1天告警一次'
}
